<template lang="pug">
.insights-timeline-details
  .insights-timeline-popover-header
    div
      h6.mb-0.inline-block
        | {{ details.start | formatTimeRangeNoSeconds(details.stop) }}
      .insights-timeline-popover-date {{ format(details.start) }}
    .badge.insights-timeline-popover-badge(
      v-if="status"
      :class="statusClass"
    )
      i.mr-5(:class="statusIcon")
      | {{ statusText }}
  .insights-timeline-popover-body
    template(v-if="hasData")
      .insights-timeline-popover-percentages
        .percentage-section
          .insights-timeline-popover-list-title Core Work
          .percentage {{ proficiencyScore }}

        .percentage-section
          .insights-timeline-popover-list-title Activity
          .percentage {{ activity }}
        .percentage-section(v-if="hasLocationType")
          .insights-timeline-popover-list-title Location
          .percentage.legend-label
            i(
              v-if="rawLocationType !== 'unknown'"
              :class="`hi shape insights-benchmarks-averages-color-${rawLocationType}`"
            )
            span {{ locationType }}

      .insights-timeline-popover-list(v-if="hasProjects")
        .insights-timeline-popover-list-title Projects
        .insights-timeline-popover-list-projects {{ projects }}

      .insights-timeline-popover-list(
        v-if="hasTools || toolsHidden"
        :class="{ 'insights-timeline-popover-list-flex': tools.length > 5 }"
      )
        .insights-timeline-popover-list-title Apps &amp; URLs
        img.data-privacy.w-full(
          v-if="toolsHidden"
          :src="dataPrivacyPlaceholder.src"
        )
        ul.tools-list(v-else)
          li(
            v-for="tool in tools"
            :key="tool.name"
          )
            i.insights-proficiency-speck.mr-5(:class="toolClasses(tool.proficiency)")
            | {{ tool.name }}
    InsightsNoData(
      v-else
      type="no_data"
    )
</template>

<script>
import { kebabCase } from 'lodash-es';
import { formatDate } from '~/utils/time_utils.js';
import { INSIGHTS, INSIGHTS_ASSETS as insightsAssets } from '~/app_constants';

export default {
  name: 'InsightsTimelineDetails',
  components: {
    InsightsNoData: () => import('~/components/insights/InsightsNoData.vue'),
  },
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    dataPrivacyPlaceholder: insightsAssets.timeline_placeholder,
  }),
  computed: {
    projects() {
      return this.details.meta.projects?.map((project) => project.name).join(', ');
    },
    toolsHidden() {
      return this.details.meta.toolsHidden;
    },
    tools() {
      return this.details.meta.tools;
    },
    hasProjects() {
      return !!(this.projects && this.projects.length);
    },
    hasTools() {
      return !!(this.tools && this.tools.length);
    },
    hasData() {
      return this.hasTools || this.hasProjects;
    },
    proficiencyScore() {
      return this.details.meta.proficiencyScore !== null
        ? `${this.formatPercentage(this.details.meta.proficiencyScore)}%`
        : '-';
    },
    activity() {
      return this.details.meta.activity !== null ? `${this.formatPercentage(this.details.meta.activity * 100)}%` : '-';
    },
    status() {
      return this.details.meta.status && INSIGHTS.timeline.status[this.details.meta.status];
    },
    statusText() {
      return this.status?.text;
    },
    statusClass() {
      return this.status?.class;
    },
    statusIcon() {
      return this.status?.icon;
    },
    rawLocationType() {
      return this.details.meta.locationType;
    },
    hasLocationType() {
      return this.rawLocationType !== null;
    },
    locationType() {
      if (!this.hasLocationType) {
        return null;
      }

      return INSIGHTS.remoteVsOffice.locationTypeNames[this.rawLocationType] || this.rawLocationType;
    },
  },
  methods: {
    toolClasses(proficiency) {
      return `proficiency-${kebabCase(proficiency)}`;
    },
    format(date) {
      return formatDate(date);
    },
    formatPercentage(number) {
      return Math.round(number * 10) / 10;
    },
  },
};
</script>
